import React from "react";
import { displayName } from "@/utils/comment_utils";
const CommentText = (props) => {
  const { comment, isEditable } = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h5", { className: "comment-text__contributor" }, displayName(comment)), !isEditable && /* @__PURE__ */ React.createElement("p", { className: "comment-text__context" }, comment.text));
};
export default CommentText;
